import _ from 'lodash';
import createSubflowsFromDefns from './_createSubflowsFromDefns';
import flowBegining from './_flowBegining';
import wireLOBSection from './_wireLOBSection';

/**
 * Returns an entry point for the given flow subsection
 * @param {Object} flow an optionally empty flow
 * @param {String} flowSectionName the name of the section in the flow where to jump to
 * @returns {Object} the entry point in the flow for the specified section
 */
function getTransition(flow, flowSectionName) {
    return _.get(flow, `${flowSectionName}.entry`, null);
}

/**
 * Translates the product code into a name identifying a sub-flow
 * @param {String} productCode the product code
 * @returns {String} a string identifying a subflow
 */
function getFlowName(productCode) {
    switch (productCode) {
        case 'PersonalAuto':
            return 'pa';
        case 'PSAUsedCarWarranty':
            return 'puw';
        case 'Homeowners':
        case 'HOPHomeowners':
            return 'ho';
        case 'CommercialProperty':
            return 'cp';
        case 'BusinessOwners':
            return 'bop';
        case 'WC7WorkersComp':
            return 'wc7';
        default:
            throw new Error(`Invalid Product code specified: ${productCode}`);
    }
}

/**
 * Returns an entry point for the subflow
 *
 * @param {Object} subFlows an object containing a subflow for each LOB
 * @param {String} productCode a string inentifying the productCode
 * @param {String} flowPropertyKey the name of the section in the subflow to which jump to
 * @returns {Object} the entry point for the subflow section
 */
export function flowTransition(subFlows, productCode, flowPropertyKey) {
    const chosenFlowName = getFlowName(productCode);
    const chosenFlow = _.get(subFlows, chosenFlowName, null);
    return getTransition(chosenFlow, flowPropertyKey);
}

export default ['AvailabilityService', 'qnb.LoadSaveService', '$q', 'TranslateService', 'ViewModelService', 'qnb.ViewModelCtx', 'qnb.ActionMessageUtil', 'EventHub', 'QuoteJumpToStepService',
    function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ActionMessageUtil, EventHub, QuoteJumpToStepService) {

        function branchOnProductCode(subFlows, flowPropertyKey) {
            // given submission, it return a function that transitions to the appropriate subflow
            return ({ value: submission }) => flowTransition(subFlows, submission.baseData.productCode, flowPropertyKey);
        }

        return function (step, junction, flow) {

            const subFlows = createSubflowsFromDefns(flow, AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ActionMessageUtil, EventHub, QuoteJumpToStepService);
            // create complete flow by wiring up sub flows
            flowBegining(subFlows)(step, junction);
            wireLOBSection(subFlows, branchOnProductCode)();
        };
    }
];
